import React from 'react';

const IconBase = ({ className = 'w-5 h-5', strokeWidth = 1.9, children }) => (
  <svg
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth={strokeWidth}
    strokeLinecap="round"
    strokeLinejoin="round"
    className={className}
    aria-hidden="true"
  >
    {children}
  </svg>
);

export const CheckIcon = ({ className }) => (
  <IconBase className={className}>
    <path d="m5 12 4 4L19 6" />
  </IconBase>
);

export const CheckCircleIcon = ({ className }) => (
  <IconBase className={className}>
    <circle cx="12" cy="12" r="9" />
    <path d="m8.5 12 2.5 2.5 4.5-5" />
  </IconBase>
);

export const CoinsIcon = ({ className }) => (
  <IconBase className={className}>
    <ellipse cx="12" cy="6" rx="6.5" ry="2.5" />
    <path d="M5.5 6v4c0 1.4 2.9 2.5 6.5 2.5s6.5-1.1 6.5-2.5V6" />
    <path d="M5.5 10v4c0 1.4 2.9 2.5 6.5 2.5s6.5-1.1 6.5-2.5v-4" />
  </IconBase>
);

export const CreditCardIcon = ({ className }) => (
  <IconBase className={className}>
    <rect x="3" y="5" width="18" height="14" rx="2.5" />
    <path d="M3 10h18" />
    <path d="M7 15h3" />
  </IconBase>
);

export const BanknoteIcon = ({ className }) => (
  <IconBase className={className}>
    <rect x="3" y="6" width="18" height="12" rx="2" />
    <circle cx="12" cy="12" r="2.5" />
    <path d="M7 9h.01M17 15h.01" />
  </IconBase>
);

export const FileTextIcon = ({ className }) => (
  <IconBase className={className}>
    <path d="M14 3H7a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V8z" />
    <path d="M14 3v5h5" />
    <path d="M9 13h6M9 17h6" />
  </IconBase>
);

export const ShieldLockIcon = ({ className }) => (
  <IconBase className={className}>
    <path d="M12 3 5 6v5c0 4.2 2.8 7.9 7 9 4.2-1.1 7-4.8 7-9V6z" />
    <rect x="9.2" y="11.2" width="5.6" height="4.8" rx="1" />
    <path d="M10.5 11.2v-1a1.5 1.5 0 0 1 3 0v1" />
  </IconBase>
);

export const MailIcon = ({ className }) => (
  <IconBase className={className}>
    <rect x="3" y="5.5" width="18" height="13" rx="2" />
    <path d="m4 7 8 6 8-6" />
  </IconBase>
);

export const CameraIcon = ({ className }) => (
  <IconBase className={className}>
    <rect x="3" y="7" width="18" height="12" rx="2.5" />
    <path d="M9 7 10.5 5h3L15 7" />
    <circle cx="12" cy="13" r="3" />
  </IconBase>
);

export const BuildingIcon = ({ className }) => (
  <IconBase className={className}>
    <path d="M4 20h16" />
    <path d="M6 20V8l6-3 6 3v12" />
    <path d="M9 11h.01M12 11h.01M15 11h.01M9 14h.01M12 14h.01M15 14h.01" />
  </IconBase>
);

export const PackageIcon = ({ className }) => (
  <IconBase className={className}>
    <path d="m3 8 9-5 9 5-9 5-9-5Z" />
    <path d="M3 8v8l9 5 9-5V8" />
    <path d="M12 13v8" />
  </IconBase>
);

export const ShoppingCartIcon = ({ className }) => (
  <IconBase className={className}>
    <path d="M3 4h2l2.1 10.2a2 2 0 0 0 2 1.6h7.9a2 2 0 0 0 2-1.6L22 7H7" />
    <circle cx="10" cy="20" r="1.4" />
    <circle cx="18" cy="20" r="1.4" />
  </IconBase>
);

export const TicketIcon = ({ className }) => (
  <IconBase className={className}>
    <path d="M4 8a2 2 0 0 0 0 4v4h16v-4a2 2 0 0 0 0-4V4H4z" />
    <path d="M12 4v12" />
  </IconBase>
);

export const AlertTriangleIcon = ({ className }) => (
  <IconBase className={className}>
    <path d="m12 4.5 8 14H4l8-14Z" />
    <path d="M12 9v4" />
    <path d="M12 15.5h.01" />
  </IconBase>
);

export const ImageIcon = ({ className }) => (
  <IconBase className={className}>
    <rect x="3" y="5" width="18" height="14" rx="2" />
    <circle cx="9" cy="10" r="1.5" />
    <path d="m21 15-4-4-5 5-2-2-5 5" />
  </IconBase>
);

export const ScrollIcon = ({ className }) => (
  <IconBase className={className}>
    <path d="M7 6h10a2 2 0 0 1 0 4H7a2 2 0 0 0 0 4h10" />
    <path d="M7 18a2 2 0 1 1 0-4" />
  </IconBase>
);

export const FilterIcon = ({ className }) => (
  <IconBase className={className}>
    <path d="M4 6h16" />
    <path d="M7 12h10" />
    <path d="M10 18h4" />
  </IconBase>
);

export const XIcon = ({ className }) => (
  <IconBase className={className}>
    <path d="M18 6 6 18" />
    <path d="m6 6 12 12" />
  </IconBase>
);

export const ChevronDownIcon = ({ className }) => (
  <IconBase className={className}>
    <path d="m6 9 6 6 6-6" />
  </IconBase>
);

export const PlusIcon = ({ className }) => (
  <IconBase className={className}>
    <path d="M12 5v14" />
    <path d="M5 12h14" />
  </IconBase>
);

export const MinusIcon = ({ className }) => (
  <IconBase className={className}>
    <path d="M5 12h14" />
  </IconBase>
);

export const TrashIcon = ({ className }) => (
  <IconBase className={className}>
    <path d="M4 7h16" />
    <path d="M10 11v6" />
    <path d="M14 11v6" />
    <path d="M6 7l1 12a2 2 0 0 0 2 2h6a2 2 0 0 0 2-2l1-12" />
    <path d="M9 7V4.5a1.5 1.5 0 0 1 1.5-1.5h3A1.5 1.5 0 0 1 15 4.5V7" />
  </IconBase>
);

export const CircleOffIcon = ({ className }) => (
  <IconBase className={className}>
    <circle cx="12" cy="12" r="9" />
    <path d="M6.5 6.5 17.5 17.5" />
  </IconBase>
);

export const ArrowLeftIcon = ({ className }) => (
  <IconBase className={className}>
    <path d="M19 12H5" />
    <path d="m12 19-7-7 7-7" />
  </IconBase>
);

export const MenuIcon = ({ className }) => (
  <IconBase className={className}>
    <path d="M4 7h16" />
    <path d="M4 12h16" />
    <path d="M4 17h16" />
  </IconBase>
);

export const CalendarIcon = ({ className }) => (
  <IconBase className={className}>
    <rect x="3" y="5" width="18" height="16" rx="2" />
    <path d="M8 3v4M16 3v4M3 10h18" />
  </IconBase>
);

export const TagIcon = ({ className }) => (
  <IconBase className={className}>
    <path d="M20 10.6 13.4 4H6v7.4l6.6 6.6a2 2 0 0 0 2.8 0l4.6-4.6a2 2 0 0 0 0-2.8Z" />
    <circle cx="8.5" cy="8.5" r="1.2" />
  </IconBase>
);

export const ChevronLeftIcon = ({ className }) => (
  <IconBase className={className}>
    <path d="m15 18-6-6 6-6" />
  </IconBase>
);

export const ChevronRightIcon = ({ className }) => (
  <IconBase className={className}>
    <path d="m9 6 6 6-6 6" />
  </IconBase>
);
